import React, { useState, useEffect } from "react";
import PortalModal from "../../Portals";
import InfoIcon from "@material-ui/icons/Info";
import { NotificationManager } from "react-notifications";
import {
  ContentModalActiveSurvey,
  ContentModal,
  SOSButton,
  ErrorMessage,
} from "./ICEButtonContainer.styled";
import { clientWellness } from "../../App";
import { useMutation, useLazyQuery } from "@apollo/client";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { cookie } from "../../util/JWTCookie";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import { SEND_ICE_ALERT } from "../../GraphQL/Mutations";
import { GET_ICE_BUTTON_STATUS } from "../../GraphQL/Queries";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { theme as themeConfig } from "../../themes/themes";

export const ICEButtonContainer = () => {
  const [activeDirectoryToken, setActiveDirectoryToken] = useState("");
  const [user, setUser] = useState(getStateLoginComplete());
  const [iceStatus, setICEStatus] = useState("Closed");
  const [connection, setConnection] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [showICEButton, setShowICEButton] = useState(true);
  const [isActiveConnection, setIsActiveConnection] = useState(false);

  const getTokenApp = async (data) => {
    const opts = {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + data.accessToken,
      }),
    };
    const response = await fetch(process.env.LOGIN_URL, opts).then((res) => {
      if (res.status === 200) return res.text();
    });
    return response;
  };

  const token = async (data) => {
    setShowLoader(true);
    const response = await getTokenApp(data);
    setShowLoader(false);
    const resObj = JSON.parse(response);
    if (resObj && resObj?.accessToken) {
      cookie.set("TrustSafety", resObj);
      setUser(getStateLoginComplete());
      setIsActiveConnection(true);
    } else {
      setShowICEButton(false);
      NotificationManager.warning("User does not exist", "", 5000);
    }
  };

  const [sendIceAlert] = useMutation(SEND_ICE_ALERT, {
    client: clientWellness,
  });

  const [runQueryGetICEStatus] = useLazyQuery(GET_ICE_BUTTON_STATUS, {
    fetchPolicy: "network-only",
    client: clientWellness,
    onCompleted: (response) => {
      if (response?.iceRequestButtonStatusByUser) {
        setICEStatus(response.iceRequestButtonStatusByUser);
      }
    },
  });

  useEffect(() => {
    async function getTokenFromNotify() {
      if (window.NOTIFY_BRIDGE) {
        let paramsFromNotify = await window.NOTIFY_BRIDGE.getParams();
        if (paramsFromNotify?.adToken) {
          setActiveDirectoryToken(paramsFromNotify.adToken);
        }
      }
    }
    getTokenFromNotify();
  }, []);

  useEffect(() => {
    if (activeDirectoryToken) {
      token({ accessToken: activeDirectoryToken });
    }
  }, [activeDirectoryToken]);

  useEffect(() => {
    if (user) {
      runQueryGetICEStatus();
    }
  }, [user]);

  useEffect(() => {
    if (isActiveConnection) {
      let accesToken = cookie.getToken("TrustSafety");
      const newConnection = new HubConnectionBuilder()
        .withUrl(process.env.API_REST_WELLNESS_REALTIME, {
          accessTokenFactory: () => accesToken,
        })
        .withAutomaticReconnect()
        .build();
      setConnection(newConnection);
    }
  }, [isActiveConnection]);

  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then((result) => {
          connection.on("receiveIceButtonStatus", (data) => {
            setICEStatus(data);
          });
        })
        .catch((error) => {
          setShowICEButton(false);

          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  }, [connection]);

  let handleSendIceAlert = () => {
    setShowLoader(true);
    sendIceAlert()
      .then((res) => {
        if (res.data.sendIceAlert) {
          NotificationManager.success("The notification is sent", "", 5000);
          setICEStatus("Open");
        }
        setShowLoader(false);
      })
      .catch((error) => {
        setShowLoader(false);
        setShowICEButton(false);

        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let showErrorMessage = () => {
    return (
      <ErrorMessage>
        <h1 style={{ paddingBottom: "1rem" }}>Something went wrong!</h1>
        <h4>Please close this window and reopen again.</h4>
      </ErrorMessage>
    );
  };

  if (!activeDirectoryToken || !showICEButton) {
    return showErrorMessage();
  }

  return (
    <PortalModal>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100vw",
        }}
      >
        {showLoader && <ModalLoader></ModalLoader>}
        {!showLoader && showICEButton && (
          <ContentModalActiveSurvey>
            <ContentModal>
              <p style={{ marginRight: '1em' }}>
                <b>Quick Assist</b>
              </p>
              <div className="content-sos-button">
                <SOSButton
                  buttonStatus={iceStatus}
                  onClick={() => handleSendIceAlert()}
                >
                  {/* I.C.E */}
                  <p className="push-here">PUSH HERE</p>
                </SOSButton>
              </div>
              {iceStatus !== "Open" ? (
                <p>
                  <span>
                    <InfoIcon style={{ color: themeConfig.text.primary }} />
                  </span>
                  Press this button <b>ONLY</b> if you feel that you need{" "}
                  <b>IMMEDIATE</b> help from your wellness team.
                </p>
              ) : (
                <p>
                  <b>You will be contacted soon</b>
                </p>
              )}
            </ContentModal>
          </ContentModalActiveSurvey>
        )}
      </div>
    </PortalModal>
  );
};

export default ICEButtonContainer;
